import { CommentOutlined } from "@ant-design/icons";
import { Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import React from "react";
import { useTranslation } from "react-i18next";
import { normalizeCountry } from "../../helpers/tools";
import ListLanguage from "./ListLanguage";
import { useSelector } from "react-redux";
import { getSupplierData } from "../../Redux/Selectors/appConfigSelector";
import { filterLanguagesByCountry } from "../../tools/countries";

const LanguageTab = ({ onChangeLanguage }) => {
  const { t } = useTranslation(["experiences"]);
  const { country } = useSelector(getSupplierData);

  const renderLanguages = () => {
    const languages = filterLanguagesByCountry(normalizeCountry(country));
    return languages.map((item) => (
      <ListLanguage
        onClick={() => onChangeLanguage({ key: item.code })}
        label={`${item.name} ${item.symbol}`}
        icon={item.flagIcon()}
        key={item.code}
      />
    ));
  };

  return (
    <Tabs defaultActiveKey="1">
      <TabPane
        tab={
          <span>
            <CommentOutlined />
            {t("language_other")}
          </span>
        }
        key="1"
      >
        {renderLanguages()}
      </TabPane>
    </Tabs>
  );
};

export default LanguageTab;
